( function( $ ) {
  /* Initiate the superfish submenu */
  $( '.dp-desktop-menu' ).superfish();
  
  /* Sticky Header */
  if ( $(window).scrollTop() <= 50 ) {
    $( '.__main_header' ).removeClass( '__sticky' );
  } else {
    $( '.__main_header' ).addClass( '__sticky' );
  }
  $( window ).scroll( function() {
    if ( $(window).scrollTop() <= 50 ) {
      $( '.__main_header' ).removeClass( '__sticky' );
    } else {
      $( '.__main_header' ).addClass( '__sticky' );
    }
  } );

  /* Mobile Menu */
  $( document ).on( 'click touchstart', '.hamburger', function() {
    if( $( this ).hasClass( 'is-active' ) ) {
      $( this ).removeClass( 'is-active' );
    } else {
      $( this ).addClass( 'is-active' );
    }
  } );

  /* Add show submenu in mobile menu */
  $( '.menu-item-has-children' ).prepend( '<span class="__show_children"></span>' );
  $( document ).on( 'click', '.__show_children', function() {
    if ( $( 'ul.submenu' ).is(':visible') ) {
      $( 'ul.submenu' ).slideUp( function() {
        $( '.__show_children', $( this ).parent() ).css( 'background', '#e6e6e6 url('+ localized_obj.dir +'/assets/images/menu-arrow-right.png) center/auto no-repeat' );
      } );
    }

    var parent_li = $( this ).parent();
    if ( $( 'ul', parent_li ).is(':visible') ) {
      $( 'ul', parent_li ).slideUp( function() {
        $( '.__show_children', parent_li ).css( 'background', 'url('+ localized_obj.dir +'/assets/images/menu-arrow-right.png) center/auto no-repeat' );
      } );
    } else {
      $( 'ul', parent_li ).slideDown( function() {
        $( '.__show_children', parent_li ).css( 'background', 'url('+ localized_obj.dir +'/assets/images/menu-arrow-down.png) center/auto no-repeat' );
      } ); 
    }
  } );

  /* Initiate sidr function to enable mobile menu */
  $( '.hamburger' ).sidr( {
    name: 'mobile-menu',
    side: 'right',
    onOpen: function() {
      $( 'header' ).css( {
        /*right: '250px'*/
      } );
    },
    onClose: function() {
      $( 'header' ).css( {
        right: '0'
      } );
    }
  } );

  /**
   * Add class in header to determine
   * if the menu is desktop menu to adjust
   * the position of this part
   */
  $( window ).on( 'resize', function() {
    if ( $( window ).width() > 920 ) {
      $( 'body' ).addClass( '__uncollapsed_menu' );
    } else {
      $( 'body' ).removeClass( '__uncollapsed_menu' );
    }
  } );
} ) ( jQuery );